import { render, staticRenderFns } from "./associated_phoria.config.vue?vue&type=template&id=18d69a16"
import script from "./associated_phoria.config.vue?vue&type=script&lang=js"
export * from "./associated_phoria.config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports